/**
 * Parse postsCategory from JSON array string or legacy comma-separated format.
 * Supports backward compatibility with old comma-separated format.
 *
 * New format: '["Tag1","Tag2"]' (JSON array string)
 * Legacy format: 'Tag1,Tag2' (comma-separated string)
 *
 * @param value - The postsCategory attribute value
 * @returns Array of category/tag names
 */
export const parsePostsCategory = (value: string | undefined): string[] => {
  if (!value || value === 'all') return [];

  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed)) {
      return parsed;
    }
  } catch {
    // JSON parse failed, fall through to legacy format
  }

  // Backward compat for old comma-separated format
  return value
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
};
